import { useNavigate } from "react-router-dom";
import Content from "../../components/content/Content";
import ContentBody from "../../components/content/ContentBody";
import ContentHead from "../../components/content/ContentHead";
import Table from "../../components/table/table";
import { faAdd, faClose, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputField from "../../components/inputField/inputField";
import toast from "react-hot-toast";
import {
  getAllApi,
  getSoftwareOutsourcing,
  updateDedicatedTeams,
  updateSoftwareOutsourcing,
  uploadImageApi,
} from "../../api";
import { useEffect, useState } from "react";
import ToggleSwitch from "../../components/toggleSwitch";
import Modal from "../../components/modal/modal";
import he from "he";
import TextEditor from "../../components/textEditor/textEditor";
import { isValidURL } from "../../utils/isValidUrl";

const SoftwareOutsourcing = () => {
  const navigate = useNavigate();
  const [fold1Title, setFold1Title] = useState("");
  const [fold1Description, setFold1Description] = useState("");
  const [fold2Title, setFold2Title] = useState("");
  const [fold2Description, setFold2Description] = useState("");
  const [fold2List, setFold2List] = useState([]);
  const [fold2ListHeading, setFold2ListHeading] = useState("");
  const [fold3Heading, setFold3Heading] = useState("");
  const [fold3BtnText, setFold3BtnText] = useState("");
  const [fold3BtnLink, setFold3BtnLink] = useState("");
  const [blogs, setBlogs] = useState([]);
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [hero, setHero] = useState([]);
  const [fold3BtnShow, setFold3BtnShow] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [slug, setSlug] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [id, setId] = useState("");
  const [modal, setModal] = useState(false);
  const [deleteFrom, setDeleteFrom] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [qanda, setQandA] = useState([]);
  const [qandaHeading, setQandAHeading] = useState("");
  const [metaImageUrl, setMetaImageUrl] = useState("");

  useEffect(() => {
    getBlogs();
  }, []);

  const getBlogs = () => {
    getAllApi("article")
      .then((response) => {
        console.log(response.data);
        setBlogs(response.data);
        getData();
      })
      .catch((error) => {
        console.log(error);
        setBlogs([]);
        toast.error("Something went wrong while fetching blogs.");
        getData();
      });
  };

  const getData = () => {
    getSoftwareOutsourcing()
      .then((res) => {
        setHero(res.data[0].hero);

        setId(res.data[0]._id);

        const f1 = res.data[0].fold_1;
        setFold1Title(f1?.title || "");
        setFold1Description(he.decode(f1?.description || ""));

        const f2 = res.data[0].fold_2;
        setFold2Title(f2?.title || "");
        setFold2Description(he.decode(f2?.description || ""));
        setFold2ListHeading(f2?.listHeading);
        setFold2List(
          f2?.content.map((v) => ({
            ...v,
            icon: { url: v.icon, obj: "" },
            description: he.decode(v?.description || ""),
          }))
        );

        const f3 = res.data[0].fold_3;
        setFold3Heading(f3?.heading);
        setFold3BtnText(f3?.buttonText);
        setFold3BtnLink(f3?.buttonLink);
        setFold3BtnShow(f3?.buttonShow);

        setRelatedBlogs(res.data[0].relatedArticle.map((val) => val._id));

        setQandAHeading(he.decode(res.data[0]?.fanda?.heading || ""));
        setQandA(
          res.data[0]?.fanda?.details?.map((val) => ({
            question: he.decode(val.question),
            answer: he.decode(val.answer),
          })) || []
        );

        setSlug(res.data[0].metaData?.slug);
        setMetaTitle(res.data[0].metaData?.metaTitle);
        setMetaImageUrl(res.data[0].metaData?.metaImageUrl);
        setMetaDescription(res.data[0].metaData?.metaDescription);
        setCanonicalUrl(res.data[0].metaData?.canonicalUrl);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const getFold2Data = async () => {
    const fd = {
      title: fold2Title,
      description: fold2Description,
      listHeading: fold2ListHeading,
      content: [],
    };

    for (let i = 0; i < fold2List.length; i++) {
      if (fold2List[i].icon?.obj) {
        const response = await uploadImageApi(
          fold2List[i].icon.obj,
          "technology"
        );
        fd.content.push({
          ...fold2List[i],
          icon: response.data.imageUrl,
        });
      } else {
        fd.content.push({
          ...fold2List[i],
          icon: fold2List[i].icon.url,
        });
      }
    }

    return fd;
  };

  const validate = () => {
    const validationCheck = [
      {
        condition: !fold1Title,
        message: "Fold 1 Title is required.",
      },
      {
        condition: !fold1Description,
        message: "Fold 1 Description is required.",
      },
      {
        condition: fold2List.length === 0,
        message: "Fold 2 is required.",
      },
      {
        condition: !fold2Title,
        message: "Fold 2 Title is required.",
      },
      {
        condition: !fold2Description,
        message: "Fold 2 Description is required.",
      },
      {
        condition: !fold2ListHeading,
        message: "Fold 2 List heading is required.",
      },
      {
        condition: fold2List.some((v) => !v.icon.url),
        message: "Fold 2 Icon is required.",
      },
      {
        condition: fold2List.some((v) => !v.iconCaption),
        message: "Fold 2 Icon Caption is required.",
      },
      {
        condition: fold2List.some((v) => !v.iconAlt),
        message: "Fold 2 Icon Alt is required.",
      },
      {
        condition: fold2List.some((v) => !v.title),
        message: "Fold 2 title is required.",
      },
      {
        condition: fold2List.some((v) => !v.description),
        message: "Fold 2 Description is required.",
      },
      // Fold 3
      {
        condition: !fold3Heading,
        message: "Fold 3 Heading is required.",
      },
      {
        condition: fold3BtnShow && !fold3BtnText,
        message: "Fold 3 Button text is required.",
      },
      {
        condition: fold3BtnShow && !fold3BtnLink,
        message: "Fold 3 Button Link is required.",
      },
      {
        condition: fold3BtnShow && !isValidURL(fold3BtnLink),
        message: "Fold 3 Button Link is invalid.",
      },
      // f and q
      {
        condition: qanda.length === 0,
        message: "F&Q is required.",
      },
      {
        condition: !qandaHeading,
        message: "F&Q heading is required.",
      },
      {
        condition: qanda.some((v) => !v.question),
        message: "F&Q Question is required.",
      },
      {
        condition: qanda.some((v) => !v.answer),
        message: "F&Q Answer is required.",
      },
      // related articles
      {
        condition: relatedBlogs.length === 0,
        message: "Related Articles are required.",
      },
      // meta data
      {
        condition: !metaTitle,
        message: "Meta Title is required.",
      },
      {
        condition: !metaImageUrl,
        message: "Meta Image Url is required.",
      },
      {
        condition: !isValidURL(metaImageUrl),
        message: "Meta Image Url is not valid",
      },
      {
        condition: !metaDescription,
        message: "Meta Description is required.",
      },
      {
        condition: !canonicalUrl,
        message: "Canonical Url is required.",
      },
      {
        condition: !isValidURL(canonicalUrl),
        message: "Canonical Url is not valid.",
      },
    ];

    for (const check of validationCheck) {
      if (check.condition) {
        toast.error(check.message);
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    if (validate()) {
      setLoading(true);

      const data = {
        hero: hero,
        fold_1: {
          title: fold1Title,
          description: fold1Description,
        },
        fold_3: {
          heading: fold3Heading,
          buttonText: fold3BtnText,
          buttonLink: fold3BtnLink,
          buttonShow: fold3BtnShow,
        },
        relatedArticle: relatedBlogs,
        fanda: {
          heading: qandaHeading,
          details: qanda,
        },
        metaData: {
          slug,
          metaTitle,
          metaImageUrl,
          metaDescription,
          canonicalUrl,
        },
      };

      data.fold_2 = await getFold2Data();

      console.log("data to submit", data);

      updateSoftwareOutsourcing(data, id)
        .then((res) => {
          toast.success("Updated Successfully.");
          setIsChanged(false);
          getData();
        })
        .catch((err) => {
          console.log("Errror ::: ", err);
          toast.error("Something went wrong.");
          setLoading(false);
        });
    }
  };

  const handleDelete = () => {
    setModal(false);
    setLoading(true);

    if (deleteFrom === "hero") {
      if (hero.length === 1) {
        updateSoftwareOutsourcing({ hero: [] }, id)
          .then(() => {
            getData();
          })
          .catch(() => {
            setLoading(false);
            toast.error("Something went wrong while deleting hero element.");
          });
      } else {
        updateSoftwareOutsourcing(
          {
            hero: hero.filter((val) => val._id !== deleteId),
          },
          id
        )
          .then(() => {
            toast.success("Deleted Successfully.");
            getData();
          })
          .catch(() => {
            setLoading(false);
            toast.error("Something went wrong while deleting hero element.");
          });
      }
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "rgba(0,0,0,.3)",
            zIndex: 100000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span className="loader"></span>
        </div>
      )}
      <Modal
        title={"Delete"}
        description={
          "Do you really want to delete this record? This process cannot be undone."
        }
        onBtn1Click={() => {
          setDeleteFrom("");
          setDeleteId("");
          setModal(false);
        }}
        onBtn2Click={handleDelete}
        state={modal}
      />
      <Content>
        <ContentHead
          title="Software Outsourcing"
          showBtn1={isChanged}
          showBtn2={isChanged}
          btn1Text="Save"
          btn1Name="btn1"
          btn2Text="Cancel"
          btn1type="filled"
          btn2type="outlined_del"
          btn2Name="btn2"
          onClickHandler={(e) => {
            if (e.target.name === "btn1") {
              handleSubmit();
            } else {
              navigate("/software-outsourcing");
            }
          }}
        />
        <ContentBody>
          <div className="grid">
            <div className="card grid">
              <h3>
                Hero{" "}
                <button
                  onClick={() => {
                    navigate("/software-outsourcing/hero/add");
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} />
                  Add
                </button>
              </h3>
              <Table
                head={[{ title: "S.No." }, { title: "Title" }, { title: "" }]}
                body={hero}
                body_keys={["title", "action:delete"]}
                number={true}
                onRowClick={(e) => {
                  navigate("/software-outsourcing/hero/" + e._id);
                }}
                onActionClick={(_, v2) => {
                  setDeleteFrom("hero");
                  setDeleteId(v2);
                  setModal(true);
                }}
              ></Table>
            </div>
            <div className="card grid">
              <h3>Fold 1</h3>
              <InputField
                type="text"
                isLabel={true}
                lable={"Title"}
                value={fold1Title}
                onChange={(e) => {
                  setIsChanged(true);
                  setFold1Title(e.target.value);
                }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <p style={{ paddingLeft: "5px" }}>Description</p>
                <TextEditor
                  handleChange={(val) => {
                    setIsChanged(true);
                    setFold1Description(val);
                  }}
                  content={fold1Description}
                  smallEditor={true}
                />
              </div>
            </div>
            <div className="card grid">
              <h3>
                Fold 2{" "}
                <button
                  onClick={() => {
                    setFold2List((prev) => [
                      ...prev,
                      {
                        title: "",
                        icon: { url: "", obj: "" },
                        description: "",
                        iconCaption: "",
                        iconAlt: "",
                      },
                    ]);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} /> Add
                </button>
              </h3>
              {fold2List.length !== 0 && (
                <>
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Title"}
                    value={fold2Title}
                    onChange={(e) => {
                      setIsChanged(true);
                      setFold2Title(e.target.value);
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <p style={{ paddingLeft: "5px" }}>Description</p>
                    <TextEditor
                      handleChange={(val) => {
                        setIsChanged(true);
                        setFold2Description(val);
                      }}
                      content={fold2Description}
                      smallEditor={true}
                    />
                  </div>
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"List Heading"}
                    value={fold2ListHeading}
                    onChange={(e) => {
                      setIsChanged(true);
                      setFold2ListHeading(e.target.value);
                    }}
                  />
                </>
              )}
              {fold2List.map((value, index) => (
                <div key={index} className="sub_card grid">
                  <FontAwesomeIcon
                    icon={faClose}
                    className="sub_card_close"
                    onClick={() => {
                      let temp = fold2List;
                      temp.splice(index, 1);
                      setFold2List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <div>
                    <p style={{ fontSize: ".9rem" }}>Icon</p>
                    {value.icon.url ? (
                      <div
                        style={{
                          width: "70px",
                          height: "70px",
                          background: "var(--blue-light)",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "5px",
                          position: "relative",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faClose}
                          style={{
                            color: "var(--blue-dark)",
                            cursor: "pointer",
                            height: "15px",
                            width: "15px",
                            padding: "5px",
                            position: "absolute",
                            top: 0,
                            right: 0,
                            transform: "translate(50%, -50%)",
                          }}
                          onClick={() => {
                            let temp = [...fold2List];
                            temp[index].icon = { url: "", obj: "" };
                            setFold2List(temp);
                            setIsChanged(true);
                          }}
                        />
                        <img
                          src={value.icon.url}
                          alt=""
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "70px",
                          height: "70px",
                          position: "relative",
                          background: "var(--blue-light)",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "5px",
                        }}
                      >
                        <input
                          type="file"
                          style={{
                            position: "absolute",
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            opacity: 0,
                          }}
                          accept="image/*"
                          onChange={(e) => {
                            let temp = [...fold2List];
                            temp[index].icon = {
                              url: URL.createObjectURL(e.target.files[0]),
                              obj: e.target.files[0],
                            };
                            setFold2List(temp);
                            setIsChanged(true);
                          }}
                        />
                        <FontAwesomeIcon
                          icon={faPlus}
                          style={{ color: "var(--blue-dark)" }}
                        />
                      </div>
                    )}
                  </div>
                  {value.icon?.url && (
                    <div className="grid_2">
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Caption"}
                        value={value.iconCaption}
                        onChange={(e) => {
                          let temp = [...fold2List];
                          temp[index].iconCaption = e.target.value;
                          setFold2List(temp);
                          setIsChanged(true);
                        }}
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Alt"}
                        value={value.iconAlt}
                        onChange={(e) => {
                          let temp = [...fold2List];
                          temp[index].iconAlt = e.target.value;
                          setFold2List(temp);
                          setIsChanged(true);
                        }}
                      />
                    </div>
                  )}
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Title"}
                    value={value.title}
                    onChange={(e) => {
                      let temp = fold2List;
                      temp[index].title = e.target.value;
                      setFold2List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <p style={{ paddingLeft: "5px" }}>Title</p>
                    <TextEditor
                      handleChange={(val) => {
                        let temp = fold2List;
                        temp[index].description = val;
                        setFold2List([...temp]);
                        setIsChanged(true);
                      }}
                      content={value.description}
                      smallEditor={true}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="card grid">
              <h3>Fold 3</h3>
              <InputField
                type="text"
                isLabel={true}
                lable="Heading"
                value={fold3Heading}
                onChange={(e) => {
                  setFold3Heading(e.target.value);
                  setIsChanged(true);
                }}
              />

              <div className="grid_2">
                <div
                  style={{
                    height: "50px",
                    width: "100%",
                    border: "1px solid lightgrey",
                    background: "white",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    paddingInline: "15px",
                    justifyContent: "space-between",
                    marginTop: "25px",
                  }}
                >
                  <p>Show Button</p>
                  <ToggleSwitch
                    value={fold3BtnShow}
                    onClick={() => {
                      setFold3BtnShow((prev) => !prev);
                      setIsChanged(true);
                    }}
                  />
                </div>
                {fold3BtnShow && (
                  <>
                    <InputField
                      type="text"
                      isLabel={true}
                      lable="Button Text"
                      value={fold3BtnText}
                      onChange={(e) => {
                        setFold3BtnText(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      lable="Button Link"
                      value={fold3BtnLink}
                      onChange={(e) => {
                        setFold3BtnLink(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                  </>
                )}
              </div>
            </div>
            <div className="card grid">
              <h3>
                F & Q
                <button
                  onClick={() => {
                    let temp = [...qanda];
                    temp.push({
                      question: "",
                      answer: "",
                    });
                    setQandA(temp);
                    setIsChanged(true);
                  }}
                >
                  Add
                </button>
              </h3>
              {qanda.length !== 0 && (
                <div className="grid">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <p style={{ paddingLeft: "5px" }}>Heading</p>
                    <TextEditor
                      handleChange={(val) => {
                        setQandAHeading(val);
                        setIsChanged(true);
                      }}
                      content={qandaHeading}
                      smallEditor={true}
                    />
                  </div>
                  {qanda.map((value, index) => {
                    return (
                      <div className="sub_card grid" key={index}>
                        <FontAwesomeIcon
                          icon={faClose}
                          className="sub_card_close"
                          onClick={() => {
                            let temp = qanda;
                            temp.splice(index, 1);
                            setQandA([...temp]);
                            setIsChanged(true);
                          }}
                        />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <p style={{ paddingLeft: "5px" }}>Question</p>
                          <TextEditor
                            handleChange={(val) => {
                              let temp = [...qanda];
                              temp[index].question = val;

                              setQandA([...temp]);
                              setIsChanged(true);
                            }}
                            content={value.question}
                            smallEditor={true}
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <p style={{ paddingLeft: "5px" }}>Answer</p>
                          <TextEditor
                            handleChange={(val) => {
                              let temp = [...qanda];
                              temp[index].answer = val;
                              setQandA([...temp]);
                              setIsChanged(true);
                            }}
                            content={value.answer}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="card grid">
              <h3>Related Articles</h3>
              <InputField
                type="select"
                options={blogs.filter((val) => {
                  const temp = relatedBlogs.filter((v) => v === val._id);
                  return temp.length === 0 ? true : false;
                })}
                accessText="blogTitle"
                accessValue="_id"
                value=""
                onChange={(e) => {
                  setRelatedBlogs((prev) => [...prev, e.target.value]);
                  setIsChanged(true);
                }}
              />
              <div className="grid_3">
                {relatedBlogs.map((value, index) => {
                  return (
                    <div key={index} className="sub_card">
                      <FontAwesomeIcon
                        icon={faClose}
                        className="sub_card_close"
                        onClick={() => {
                          let temp = [...relatedBlogs];
                          temp.splice(index, 1);
                          setRelatedBlogs(temp);
                          setIsChanged(true);
                        }}
                      />
                      <img
                        style={{
                          width: "100%",
                          aspectRatio: "1/1",
                          objectFit: "cover",
                        }}
                        src={
                          blogs.filter((val) => val._id === value)[0]?.blogImage
                        }
                        alt=""
                      />
                      <p>
                        {blogs.filter((val) => val._id === value)[0]?.blogTitle}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="card grid">
              <InputField
                isLabel={true}
                lable="Slug"
                value={slug}
                onChange={(e) => {
                  setSlug(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Title"
                value={metaTitle}
                onChange={(e) => {
                  setMetaTitle(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Image Url"
                value={metaImageUrl}
                onChange={(e) => {
                  setMetaImageUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Description"
                value={metaDescription}
                onChange={(e) => {
                  setMetaDescription(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Canonical Url"
                value={canonicalUrl}
                onChange={(e) => {
                  setCanonicalUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
            </div>
          </div>
        </ContentBody>
      </Content>
    </>
  );
};

export default SoftwareOutsourcing;
